import { useCallback, useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { ConfirmModal } from '../common/Modal';

/** 같은 행 작업을 잃는 라우트 이동만 막는다. 새 탭·행 선택·같은 주소의 검색어 변경에는 관여하지 않는다. */
export default function SyllabusLeavePrompt({ dirty }) {
  const shouldBlock = useCallback(({ currentLocation, nextLocation }) => (
    dirty && currentLocation.pathname.replace(/\/+$/, '') !== nextLocation.pathname.replace(/\/+$/, '')
  ), [dirty]);
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (blocker.state === 'blocked' && !dirty) blocker.reset();
  }, [blocker, dirty]);

  return (
    <ConfirmModal
      isOpen={blocker.state === 'blocked' && dirty}
      title="저장 전 변경이 있습니다"
      message="저장하지 않은 조건과 복구 중인 초안이 사라집니다. 버리고 이동할까요?"
      confirmText="버리고 이동"
      cancelText="계속 작업"
      onClose={() => blocker.reset?.()}
      onConfirm={() => blocker.proceed?.()}
    />
  );
}
